import * as React from "react";
import { Game, IGameSave } from "./Game";
import { GameStage } from "./GameStage";

export interface ILoadGameProps {
    onLoad: (save: IGameSave) => void;
}
export class LoadGameComponent extends React.Component<ILoadGameProps, any> {
    load(save: IGameSave) {
        if (save.state.version < "1.1.0.650") {
            //load game was added in version 1.1.0.650
            if (save.state.stage >= GameStage.LoadGame) {
                save.state.stage++;
            }
            save.state.version = "1.1.0.650";
        }
        this.props.onLoad(save);
    }
    delete(index: number) {
        const listSave = Game.listSaves()[index];
        if (window.confirm("Are you sure you want to remove the save " + Game.gameSaveDisplayName(listSave) + "?")) {
            Game.deleteSave(index);
            this.forceUpdate();
        }
    }

    render() {

        const listSaves = Game.listSaves();
        const itemList = listSaves.reverse().map((s, i) => {
            const index = listSaves.length - i - 1;
            const display = Game.gameSaveDisplayName(s);
            return (<li key={i}><span onClick={() => { this.load(s) }}>{display}</span><i className="glyphicon glyphicon-trash text-danger" onClick={() => { this.delete(index) }} /></li>);
        });
        itemList.push((<li key="cancel" onClick={() => { this.props.onLoad(null) }}><span>Cancel</span></li>));
        return (
            <div className="container">
                <div className="col-md-8 col-md-offset-2 p-t-90">
                    <div id="mainMenu">
                        <div className="content-box">
                            <div className="logo" />
                            <h1>Load Game</h1>
                            <ul className="saveGames">{itemList}</ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
